import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import authService from './services/authService';

// Handle SSO callback before rendering the app
if (typeof window !== 'undefined' && authService.hasSsoCallbackInHash()) {
  const ssoResult = authService.handleSSOCallback();
  if (ssoResult && !ssoResult.success) {
    try {
      sessionStorage.setItem(
        'aigarage_sso_error',
        ssoResult.message || ssoResult.error || 'SSO login failed'
      );
    } catch (error) {
      console.error('Failed to save SSO error to sessionStorage:', error);
    }
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
